import { DEFAULT_MARKET } from 'components/marketplace/search/utils';

import { getServerSideProps as getMarketPageServerSideProps } from './homes/[market]';

// oxlint-disable-next-line @opendoor/no-passthrough-reexport -- Next.js route alias: /homes must serve the same page as /homes/[market].
export { default } from './homes/[market]';

export const getServerSideProps: typeof getMarketPageServerSideProps = async (context) => {
  const marketParam = context.query.m;
  const market = (Array.isArray(marketParam) ? marketParam[0] : marketParam) ?? DEFAULT_MARKET;
  const result = await getMarketPageServerSideProps({
    ...context,
    query: { ...context.query, market, is_near_me_page: undefined },
  });

  if ('notFound' in result) {
    return {
      redirect: {
        destination: `/homes/${DEFAULT_MARKET}`,
        permanent: false,
      },
    };
  }
  if (!('props' in result)) {
    return result;
  }
  return {
    props: {
      ...(await result.props),
      canonicalOverride: '/homes',
    },
  };
};
